import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Popover, Typography } from "@mui/material";
import type { FC } from "react";

import { FilterMenuTitle } from "~/components/UI/FilterMenuTitle";
import { RichTooltip } from "~/components/UI/RichTooltip";

import {
  CUSTOM_SPREAD_OPTION,
  PRESET_SPREAD_OPTIONS,
  SPREAD_TOOLTIP_TEXT,
} from "../constants";
import * as Styled from "../SpreadFilter.styles";
import { SpreadFilterEnum } from "../types";
import { SpreadCustomInput } from "./SpreadCustomInput";

interface SpreadFilterPopoverProps {
  anchorEl: HTMLElement | null;
  selectedValue: SpreadFilterEnum;
  customSpreadCents: number | null;
  onClose: () => void;
  onSelect: (value: SpreadFilterEnum | null) => void;
  onCustomChange: (value: number | null) => void;
}

export const SpreadFilterPopover: FC<SpreadFilterPopoverProps> = ({
  anchorEl,
  selectedValue,
  customSpreadCents,
  onClose,
  onSelect,
  onCustomChange,
}) => (
  <Popover
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
  >
    <Styled.PopoverContent>
      <Styled.Header>
        <FilterMenuTitle>Spread</FilterMenuTitle>
        <RichTooltip title={SPREAD_TOOLTIP_TEXT} maxWidth={280}>
          <Styled.InfoIconWrapper>
            <InfoOutlinedIcon color="disabled" fontSize="inherit" />
          </Styled.InfoIconWrapper>
        </RichTooltip>
      </Styled.Header>

      <Styled.ToggleGroup
        exclusive
        size="small"
        value={selectedValue}
        onChange={(_, value) => onSelect(value)}
      >
        {PRESET_SPREAD_OPTIONS.map((option) => (
          <Styled.PillButton key={option.value} value={option.value}>
            <Typography variant="caption">{option.label}</Typography>
          </Styled.PillButton>
        ))}
      </Styled.ToggleGroup>

      <Styled.CustomRow>
        <Styled.ToggleGroup
          exclusive
          size="small"
          value={selectedValue}
          onChange={(_, value) => onSelect(value)}
        >
          <Styled.PillButton value={CUSTOM_SPREAD_OPTION.value}>
            <Typography variant="caption">
              {CUSTOM_SPREAD_OPTION.label}
            </Typography>
          </Styled.PillButton>
        </Styled.ToggleGroup>

        {selectedValue === SpreadFilterEnum.Custom && (
          <SpreadCustomInput
            value={customSpreadCents}
            onChange={onCustomChange}
          />
        )}
      </Styled.CustomRow>
    </Styled.PopoverContent>
  </Popover>
);
